import {createFileRoute} from '@tanstack/react-router';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PathologyOverrideDelete from '@/practitioner/views/company/PathologyCustomization/PathologyOverrideDelete';

export const Route = createFileRoute(
  '/(practitioner)/company/pathology-overrides/$pathologyOverrideId/delete'
)({
  component: PathologyOverrideDelete,
  beforeLoad: grantUser(companyAdminGranted),
  loader: ({params}) => ({
    pathologyOverrideId: params.pathologyOverrideId
  })
});
